import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import '../styles/App.css';

function Layout() {
  return (
      <div className="App">
        <Header />
          <div className="App-body">
              <aside className="App-sidebar">
              </aside>
              <main className="App-feed">
                  <Outlet />
              </main>
              <aside className="App-right-aside">
              </aside>
          </div>
          <div className="App-footer">
              <Footer />
          </div>
      </div>
  );
}

export default Layout;
